import { SearchRounded } from '@mui/icons-material';
import { Grid, OutlinedInput } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useGetListDataWithPostMutation } from '../../api/apiSlice';
import Screen from '../../components/fragments/Screen';
import CardHome from '../../components/legacy/CardHome';
import { rtGetListData } from '../../store/slices/listSlice';

export default function ScreenChurchMapList() {
    const [search, setSearch] = useState('');
    const [churchList, setChurchList] = useState([]);

    const dispatch = useDispatch();

    const [getListDataWithPost, { isLoading }] =
        useGetListDataWithPostMutation();

    useEffect(() => {
        dispatch(rtGetListData('churches', 'churches'));

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const { latitude, longitude } = position.coords;
                getListDataWithPost({
                    list: 'church/finder',
                    body: { long: longitude, lat: latitude },
                }).then(({ data }) => setChurchList(data?.data || []));
            });
        } else {
            alert('Geolocation  not supported by this browser.');
        }
    }, [dispatch, getListDataWithPost]);

    return (
        <Screen loading={isLoading} title="Churches" authPass>
            <Grid item xs={12}>
                <OutlinedInput
                    value={search}
                    startAdornment={<SearchRounded className="me-2" />}
                    fullWidth
                    placeholder="Type to search"
                    onChange={(e) => setSearch(e.target.value)}
                />
            </Grid>
            {churchList
                ?.filter((church) =>
                    JSON.stringify(church)
                        .toLowerCase()
                        .includes(search.toLocaleLowerCase())
                )
                ?.map(({ id, name, location, type, username }) => (
                    <Grid key={`${id}`} item xs={12}>
                        <CardHome
                            title={name}
                            desc={`${parseInt(location?.distance)}KM away`}
                            // link={
                            //     type == 'PASTOR'
                            //         ? window.location.pathname
                            //         : id
                            //         ? `/church/${id}`
                            //         : ''
                            // }
                            link={
                                type == 'PASTOR'
                                    ? `/minister/${username}`
                                    : `/church/${id}`
                            }
                            state={{ id, name }}
                            full
                        />
                    </Grid>
                ))}
        </Screen>
    );
}
